var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRunningReport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.2891,
    cy: 25.5,
    r: 25,
    fill: "#9C4900"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9141 34.2344C20.2948 34.2344 21.4141 33.1151 21.4141 31.7344C21.4141 30.3537 20.2948 29.2344 18.9141 29.2344C17.5334 29.2344 16.4141 30.3537 16.4141 31.7344C16.4141 33.1151 17.5334 34.2344 18.9141 34.2344Z",
    stroke: "#F6EFE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4139 34.2344C32.7945 34.2344 33.9138 33.1151 33.9138 31.7344C33.9138 30.3537 32.7945 29.2344 31.4139 29.2344C30.0333 29.2344 28.9141 30.3537 28.9141 31.7344C28.9141 33.1151 30.0333 34.2344 31.4139 34.2344Z",
    stroke: "#F6EFE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4139 31.7344H13.9141V24.2344M13.9141 24.2344L16.4139 17.9844H27.6632L32.6629 24.2344M13.9141 24.2344H32.6629M32.6629 24.2344H33.9129C34.5759 24.2344 35.2117 24.4978 35.6805 24.9666C36.1493 25.4354 36.4127 26.0713 36.4127 26.7344V31.7344H33.9129M28.9132 31.7344H21.4136M25.1634 24.2344V17.9844",
    stroke: "#F6EFE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunningReport);
export default __webpack_public_path__ + "static/media/RunningReport.4637eb2a07a74a207f6695671a8fb3b6.svg";
export { ForwardRef as ReactComponent };